module.exports = __webpack_public_path__ + "static/media/work (1).5bf398bb.svg";